import { DynamicComponent } from '@gik/core/components/DynamicComponent';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Button } from '@gik/ui/Button';
import { PageSection } from '@gik/ui/gik/PageSection';
import { LayoutAside } from '@gik/ui/LayoutAside';
import React from 'react';

const blockName = 'share-your-story-cta';

function ShareYourStoryCTAComp() {
  const bem = useBemCN(blockName);

  // TODO: i18n
  return (
    <PageSection variant={'aqua'} {...bem()}>
      <LayoutAside {...bem('layout')}>
        <main {...bem('main')}>
          <p {...bem('title')}>Call for Submissions</p>
          <p {...bem('subtitle')}>Share Your Story</p>
          <p {...bem('content')}>
            Give InKind offers a platform for anyone to submit their stories, to help and inspire others to get through
            any of life’s disruptions.
          </p>
        </main>
        <aside {...bem('aside')}>
          <Button variant={'white'} externalLink href="https://create.giveinkind.com/call-for-submissions/">
            Submit your writing
          </Button>
        </aside>
      </LayoutAside>
    </PageSection>
  );
}

export function ShareYourStoryCTA() {
  return (
    <DynamicComponent height={300}>
      <ShareYourStoryCTAComp />
    </DynamicComponent>
  );
}
